<!--
 * @Author: your name
 * @Date: 2021-05-20 10:15:19
 * @LastEditTime: 2022-03-07 11:14:59
 * @LastEditors: Please set LastEditors
 * @Description: 质量改进评价弹出框
-->
<template>
  <div class="modal-window" style="padding-bottom: 40px">
    <section class="form">
      <span class="reason-title">评价问题列表：</span>
      <div class="select-table-btn">
        <more-cols
          ref="moreCols"
          class="mr-10 wn-fr"
          :show-table-col-list="tableAllColumns"
          :show-table-check-list.sync="showDefaultTable"
          @getLastCheckList="getLastCheckList"
        ></more-cols>
      </div>
      <w-table
        ref="wtTable"
        :data="wtData"
        border
        :expand-row-keys="expandRow"
        row-key="WTXH"
        :row-style="{ height: '80px' }"
        :height="readOnly ? '69vh' : '54vh'"
      >
        <w-table-column type="expand">
          <template slot-scope="scope">
            <w-form
              ref="planForm"
              label-width="120px"
              label-align="right"
              class="mb-10"
            >
              <w-form-item v-if="!readOnly" label="评价角色：" class="mt-10">
                <w-select
                  :ref="`RoleSelect_${scope.$index}`"
                  v-model="
                    pjOption.find((m) => m.WTXH == scope.row.WTXH).PJZKJB
                  "
                  placeholder="请选择"
                  @change="
                    () => {
                      changeRole(scope.row.WTXH)
                    }
                  "
                >
                  <w-option
                    v-for="item in wtRoleList(scope.row.WTXH)"
                    :key="item.PJZKJB"
                    :label="item.RoleName"
                    :value="item.PJZKJB"
                  ></w-option>
                </w-select>
              </w-form-item>
              <w-row class="mt-10">
                <w-col :span="8">
                  <w-form-item label="整改时间：">
                    <span>{{ scope.row.ZGSJ }}</span>
                  </w-form-item>
                </w-col>
                <w-col :span="8">
                  <w-form-item label="整改人：">
                    <span
                      >{{
                        scope.row.ZGR_MC
                          ? `${scope.row.ZGR_MC}(${scope.row.ZGR})`
                          : ''
                      }}
                    </span>
                  </w-form-item>
                </w-col>
                <w-col :span="8">
                  <w-form-item label="整改执行人：">
                    <span
                      >{{
                        scope.row.ZXR_MC
                          ? `${scope.row.ZXR_MC}(${scope.row.ZXR})`
                          : ''
                      }}
                    </span>
                  </w-form-item>
                </w-col>
              </w-row>
              <w-form-item label="原因分析：" class="mt-10">
                <w-input
                  :value="scope.row.YYFX"
                  type="textarea"
                  disabled
                  show-counter
                ></w-input>
              </w-form-item>
              <w-form-item label="整改措施：">
                <w-input
                  :value="scope.row.ZGCS"
                  type="textarea"
                  disabled
                  show-counter
                ></w-input>
              </w-form-item>
              <!-- 备用字段，根据后台新增 -->
              <template v-for="(item, index) in BYList">
                <w-form-item
                  v-if="item.need"
                  :key="index"
                  :label="`${item.label}：`"
                  class="mt-20"
                >
                  <w-input
                    :value="scope.row[item.name]"
                    type="textarea"
                    disabled
                    show-counter
                  ></w-input>
                </w-form-item>
              </template>
              <w-form-item
                v-if="scope.row.ZgFileList.length > 0"
                label="附件："
                label-width="120px"
              >
                <div class="file">
                  <div style="color: rgb(181 181 181)">
                    下方为已上传附件,共{{ scope.row.ZgFileList.length }}个
                  </div>
                  <div
                    v-for="item in scope.row.ZgFileList"
                    :key="item.id"
                    class="file-item"
                  >
                    <w-image
                      class="file-item-icon"
                      style="width: 80px; height: 80px"
                      :src="item.url"
                      :preview-src-list="[item.url]"
                    >
                    </w-image>
                    <w-link type="primary" :href="item.url" target="_blank">
                      {{ item.name }}
                    </w-link>
                  </div>
                </div>
              </w-form-item>
              <!-- 当前评价记录 -->
              <w-form-item v-show="pjInfo(scope.row.WTXH)" label="评价记录：">
                <w-table
                  :ref="`pjTable${scope.$index}`"
                  :data="pjInfo(scope.row.WTXH)"
                  width="80%"
                  border
                >
                  <w-table-column label="评价结果" width="120" prop="GJXGMC">
                  </w-table-column>
                  <w-table-column
                    :label="pjStr"
                    prop="GZPJ"
                    min-width="180"
                  ></w-table-column>
                  <w-table-column label="评价时间" width="120" prop="PJSJ">
                    <template slot-scope="scope1">
                      {{ moment(scope1.row.PJSJ).format('YYYY-MM-DD') }}
                    </template>
                  </w-table-column>
                  <w-table-column label="评价人" prop="PJRMC" width="150">
                    <template slot-scope="scope1">
                      {{
                        scope1.row.PJRMC
                          ? `${scope1.row.PJRMC}(${scope1.row.PJRDM})`
                          : ''
                      }}
                    </template>
                  </w-table-column>
                  <w-table-column label="审核人" width="150" prop="SHRMC">
                    <template slot-scope="scope1">
                      {{
                        scope1.row.SHRMC
                          ? `${scope1.row.SHRMC}(${scope1.row.SHRDM})`
                          : ''
                      }}
                    </template>
                  </w-table-column>
                  <w-table-column
                    label="操作"
                    v-if="!readOnly"
                    width="70"
                    align="left"
                  >
                    <template slot-scope="scope1">
                      <w-button
                        v-if="scope1.row.canDel"
                        type="error"
                        size="small"
                        icon="w-icon-close"
                        circle
                        @click="delPJ(scope1.row.JGDM)"
                      ></w-button>
                    </template>
                  </w-table-column>
                </w-table>
              </w-form-item>
            </w-form>

            <!-- 历史评价记录 -->
            <template
              v-if="
                ZGHistory_1 && ZGHistory_1.some((m) => m.WTXH == scope.row.WTXH)
              "
            >
              <w-row
                style="text-align: center; font-weight: bold; font-size: 20px"
              >
                <span>历史整改评价记录</span>
              </w-row>
              <w-form
                v-for="(wtItem, wtIndex) in ZGHistory_1.filter(
                  (m) => m.WTXH == scope.row.WTXH
                )"
                ref="history"
                :key="wtIndex"
                label-width="120px"
                label-align="right"
                class="mb-10"
              >
                <w-row v-if="ZGHistory_1 && ZGHistory_1.length > 1">
                  <span style="font-weight: bold; font-size: 16px">
                    第{{ wtIndex + 1 }}次整改评价记录
                  </span>
                </w-row>
                <w-row class="mt-10">
                  <w-col :span="8">
                    <w-form-item label="整改时间：">
                      <span>
                        {{ moment(wtItem.ZGSJ).format('YYYY-MM-DD') }}
                      </span>
                    </w-form-item>
                  </w-col>
                  <w-col :span="8">
                    <w-form-item label="整改人：">
                      <span
                        >{{
                          wtItem.ZGR_MC ? `${wtItem.ZGR_MC}(${wtItem.ZGR})` : ''
                        }}
                      </span>
                    </w-form-item>
                  </w-col>
                  <w-col :span="8">
                    <w-form-item label="整改执行人：">
                      <span
                        >{{
                          wtItem.ZXR_MC ? `${wtItem.ZXR_MC}(${wtItem.ZXR})` : ''
                        }}
                      </span>
                    </w-form-item>
                  </w-col>
                </w-row>
                <w-form-item label="原因分析：" class="mt-10">
                  <w-input
                    :value="wtItem.YYFX"
                    type="textarea"
                    disabled
                    show-counter
                  ></w-input>
                </w-form-item>
                <w-form-item label="整改措施：">
                  <w-input
                    :value="wtItem.ZGCS"
                    type="textarea"
                    disabled
                    show-counter
                  ></w-input>
                </w-form-item>
                <!-- 备用字段，根据后台新增 -->
                <template v-for="(item, index) in BYList">
                  <w-form-item
                    v-if="item.need"
                    :key="index"
                    :label="`${item.label}：`"
                    class="mt-20"
                  >
                    <w-input
                      :value="wtItem[item.name]"
                      type="textarea"
                      disabled
                      show-counter
                    ></w-input>
                  </w-form-item>
                </template>
                <w-form-item
                  v-if="
                    PJHistory_1 &&
                    PJHistory_1.filter(
                      (m) =>
                        m.WTXH == scope.row.WTXH && m.PLFXDM == wtItem.PLFXDM
                    )
                  "
                  label="评价记录："
                >
                  <w-table
                    :ref="`pjTable${scope.$index}`"
                    :data="PJHistory_1.filter((m) => m.WTXH == scope.row.WTXH)"
                    width="80%"
                    border
                  >
                    <w-table-column label="评价结果" width="120" prop="GJXGMC">
                    </w-table-column>
                    <w-table-column
                      label="评价内容"
                      prop="GZPJ"
                      min-width="180"
                    ></w-table-column>
                    <w-table-column label="评价时间" width="120" prop="PJSJ">
                      <template slot-scope="scope1">
                        {{ moment(scope1.row.PJSJ).format('YYYY-MM-DD') }}
                      </template>
                    </w-table-column>
                    <w-table-column label="评价人" prop="PJRMC" width="150">
                      <template slot-scope="scope1">
                        {{
                          scope1.row.PJRMC
                            ? `${scope1.row.PJRMC}(${scope1.row.PJRDM})`
                            : ''
                        }}
                      </template>
                    </w-table-column>
                    <w-table-column label="审核人" width="150" prop="SHRMC">
                      <template slot-scope="scope1">
                        {{
                          scope1.row.SHRMC
                            ? `${scope1.row.SHRMC}(${scope1.row.SHRDM})`
                            : ''
                        }}
                      </template>
                    </w-table-column>
                  </w-table>
                </w-form-item>
              </w-form>
            </template>
          </template>
        </w-table-column>
        <w-table-column
          v-for="item in showDefaultTable"
          :key="item.key"
          :prop="item.key"
          :label="item.name"
          :align="item.align"
          :width="item.width"
          :min-width="item.minWidth"
          :type="item.key === 'INDEX' ? 'index' : ''"
        >
        </w-table-column>
      </w-table>

      <div v-if="!readOnly" class="mt-20">
        <div>评价记录与评价：</div>
        <w-table class="mt-10" :data="pjData">
          <w-table-column label="评价结果" width="130">
            <template slot-scope="scope">
              <w-select
                v-if="scope.row.canEdit"
                ref="selectJG"
                v-model="scope.row.PJJG"
                value-key="MJDM"
                placeholder="请选择"
                @change="setPJJG(scope)"
              >
                <w-option
                  v-for="item in pjResult"
                  :key="item.MJDM"
                  :label="item.MJMC"
                  :value="item"
                ></w-option>
              </w-select>
              <span v-else>{{ scope.row.GJXGMC }}</span>
            </template>
          </w-table-column>
          <w-table-column v-if="showPj" :label="pjStr" min-width="360">
            <template slot-scope="scope">
              <span v-if="!scope.row.canEdit">
                {{ scope.row.GZPJ }}
              </span>
              <div v-else style="position: relative">
                <w-input
                  v-model="scope.row.GZPJ"
                  type="textarea"
                  :autosize="{
                    minRows: 3,
                    maxRows: 6
                  }"
                >
                </w-input>
                <w-button
                  style="position: absolute; bottom: 5px; right: 5px"
                  type="text"
                  @click="popCheckPJ(scope.row, '评价内容')"
                >
                  引用
                </w-button>
              </div>
            </template>
          </w-table-column>
          <w-table-column label="评价时间" width="180">
            <template slot-scope="scope">
              <w-date-picker
                v-if="scope.row.canEdit"
                v-model="scope.row.PJSJ"
                type="date"
                format="yyyy-MM-dd"
                style="width: 80%"
              ></w-date-picker>
              <span v-else>{{
                moment(scope.row.PJSJ).format('YYYY-MM-DD')
              }}</span>
            </template>
          </w-table-column>
          <w-table-column label="评价人" prop="PJR" width="180">
            <template slot-scope="scope">
              <span v-if="!scope.row.canEdit">
                {{
                  scope.row.PJRMC
                    ? `${scope.row.PJRMC}(${scope.row.PJRDM})`
                    : ''
                }}
              </span>
              <span v-else>
                <w-select
                  ref="select"
                  v-model="scope.row.PJR"
                  placeholder="请选择"
                  value-key="id"
                >
                  <w-option
                    v-for="item in cyList"
                    :key="item.id"
                    :label="`${item.name}(${item.id})`"
                    :value="item"
                  ></w-option>
                </w-select>
              </span>
            </template>
          </w-table-column>
          <w-table-column label="审核人" width="180">
            <template slot-scope="scope">
              <span v-if="!scope.row.canEdit">
                {{
                  scope.row.SHRMC
                    ? `${scope.row.SHRMC}(${scope.row.SHRDM})`
                    : ''
                }}
              </span>
              <span v-else>
                <w-select
                  ref="select"
                  v-model="scope.row.SHR"
                  placeholder="请选择"
                  value-key="id"
                >
                  <w-option
                    v-for="item in cyList"
                    :key="item.id"
                    :label="`${item.name}(${item.id})`"
                    :value="item"
                  ></w-option>
                </w-select>
              </span>
            </template>
          </w-table-column>
          <!-- <w-table-column width="70" align="left">
            <template slot-scope="scope">
              <w-button
                v-if="scope.row.canEdit"
                type="error"
                size="small"
                icon="w-icon-close"
                circle
                @click="delPJ(scope.$index)"
              ></w-button>
              <w-button
                v-else
                type="text"
                size="small"
                @click="scope.row.canEdit = true"
                >修改
              </w-button>
            </template>
          </w-table-column> -->
        </w-table>
        <!-- <w-button class="mt-10" size="mini" type="primary" @click="addPJ">
          新增评价
        </w-button> -->
      </div>
    </section>

    <div class="modal-window-footer" style="z-index: 99999">
      <div class="window-footer-btns">
        <w-button @click="exit()"> 取消 </w-button>
        <w-button
          v-if="!readOnly"
          type="primary"
          is-show
          @click="saveSubmit(0)"
        >
          保存
        </w-button>
        <w-button v-if="!readOnly" type="primary" @click="saveSubmit(1)">
          提交
        </w-button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { DelPJ, SavePJ } from '../../_api/index'
import zskSelect from './zskSelect.vue'
import MoreCols from '@/common/components/MoreCols'
import { getTableCheckColumns } from '@/common/utils'

export default {
  name: 'detailDialog',
  components: { MoreCols },
  props: {
    wtxhs: {
      type: String,
      default: () => ''
    },
    pjzkjb: {
      type: String,
      default: () => ''
    },
    readOnly: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      plfxdm: '', // 所有问题的整改序号集合 已逗号隔开
      fxxh: '',
      ZGHistory_1: [], //整改记录（持续整改的整改记录）
      PJHistory_1: [], // 评价记录 （持续整改的历史记录）
      UserInfo: {},
      expandRow: [],
      wtData: [],
      pjHistory: [],
      pjData: [],
      // 默认值
      pjObj: {
        canEdit: true,
        JGDM: -1,
        PJJG: {},
        GJXGDM: '',
        GJXGMC: '',
        GZPJ: '',
        PJSJ: '',
        PJR: {},
        PJRDM: '',
        PJRMC: '',
        SHR: {},
        SHRDM: '',
        SHRMC: ''
      },
      pjResult: [],
      cyList: [],
      refresh: false,
      BYList: [
        { name: 'BY1', code: '1080', need: false, label: '存在问题' },
        { name: 'BY2', code: '1081', need: false, label: '备用1' },
        { name: 'BY3', code: '1082', need: false, label: '备用1' }
      ],
      zgObj: {
        YYFX: '',
        ZGCS: '',
        BY1: '',
        BY2: '',
        BY3: '',
        ZGSJ: '',
        ZGR_MC: '',
        ZXR_MC: ''
      }, //整改信息
      showPj: true,
      pjStr: '评价内容',
      xtmj1104: false,
      xtmj1074: '0',
      tableAllColumns: [
        {
          name: '序号',
          key: 'INDEX',
          align: 'center',
          width: '62',
          keepChoosing: true,
          checked: true
        },
        {
          name: '受检科室',
          key: 'ZZJGMC',
          align: 'center',
          width: '160',
          keepChoosing: false,
          checked: true
        },
        {
          name: '检查表单',
          key: 'BDMC',
          align: 'center',
          width: '160',
          keepChoosing: false,
          checked: true
        },
        {
          name: '检查项目',
          key: 'XMMC',
          align: 'center',
          width: '220',
          keepChoosing: false,
          checked: false
        },
        {
          name: '质量标准',
          key: 'BZMC',
          align: 'center',
          width: '200',
          keepChoosing: false,
          checked: false
        },
        {
          name: '扣分标准',
          key: 'KFMC',
          align: 'center',
          width: '200',
          keepChoosing: false,
          checked: false
        },
        {
          name: '存在问题',
          key: 'CZWTMC',
          align: 'center',
          width: '200',
          keepChoosing: false,
          checked: true
        },
        {
          name: '扣分原因',
          key: 'JCKFYY',
          align: 'center',
          minWidth: 300,
          width: 300,
          keepChoosing: true,
          checked: true
        },
        {
          name: '扣分',
          key: 'JGZ',
          align: 'center',
          width: '92px',
          keepChoosing: true,
          checked: true
        },
        {
          name: '问题来源',
          key: 'ZKJBMC',
          align: 'center',
          width: '140',
          keepChoosing: false,
          checked: false
        },
        {
          name: '督查时间',
          key: 'WCSJ',
          align: 'center',
          width: '140',
          keepChoosing: false,
          checked: false
        },
        {
          name: '被查人',
          key: 'BCRMC',
          align: 'center',
          width: '100',
          keepChoosing: false,
          checked: false
        },
        {
          name: '责任人',
          key: 'ZRRMC',
          align: 'center',
          width: '120',
          keepChoosing: false,
          checked: false
        },
        {
          name: '备注',
          key: 'MEMO',
          align: 'center',
          width: '160',
          keepChoosing: false,
          checked: false
        },
        {
          name: '整改要点',
          key: 'ZGYD',
          align: 'center',
          keepChoosing: false,
          minWidth: '200px',
          checked: true
        }
      ],
      showDefaultTable: [
        {
          name: '序号',
          key: 'INDEX',
          align: 'center',
          width: '62',
          keepChoosing: true,
          checked: true
        },
        {
          name: '受检科室',
          key: 'ZZJGMC',
          align: 'center',
          width: '160',
          keepChoosing: false,
          checked: true
        },
        {
          name: '检查表单',
          key: 'BDMC',
          align: 'center',
          width: '160',
          keepChoosing: false,
          checked: false
        },
        {
          name: '存在问题',
          key: 'CZWTMC',
          align: 'center',
          width: '200',
          keepChoosing: false,
          checked: true
        },
        {
          name: '扣分原因',
          key: 'JCKFYY',
          align: 'center',
          minWidth: 300,
          width: 300,
          keepChoosing: true,
          checked: true
        },
        {
          name: '扣分',
          key: 'JGZ',
          align: 'center',
          width: '92px',
          keepChoosing: true,
          checked: true
        },
        {
          name: '整改要点',
          key: 'ZGYD',
          align: 'center',
          keepChoosing: false,
          minWidth: '200px',
          checked: true
        }
      ],
      wtMap: new Map(),
      pjQx: [],
      pjOption: [],
      pjList: [], //用于保存查到得所有评价数据
      uploadedFile: []
    }
  },
  async created() {
    this.showDefaultTable = getTableCheckColumns(
      'pj_detailDialog',
      this.tableAllColumns
    )
    this.UserInfo = this.$store.state.user.loginUserInfo
    this.pjObj.PJSJ = moment().format('YYYY-MM-DD')
    let wtxhArr = this.wtxhs.split(',')
    this.pjQx = wtxhArr.map((m) => {
      return {
        wtxh: m,
        roleList: []
      }
    })
    if (this.pjzkjb) {
      let pjzkjbArr = this.pjzkjb.split(',')
      let wtxh_plzkjbMap = new Map()
      wtxhArr.forEach((wtxh, index) => {
        if (pjzkjbArr.length >= index + 1) {
          wtxh_plzkjbMap.set(Number(wtxh), Number(pjzkjbArr[index]))
        }
      })
      this.wtMap = wtxh_plzkjbMap
    }

    let obj = { id: this.UserInfo.UserId, name: this.UserInfo.UserName }
    this.pjObj.PJR = obj
    this.pjObj.SHR = obj

    this.getPJResult()
    this.getBY()
    this.getpjqx()
    this.getxtmj()
    await this.getWtList()
  },
  mounted() {
    this.pjData.push(this.pjObj)
    this.GetZGHistory()
  },
  methods: {
    getpjqx() {
      this.$requestApi('GetPJQx', {
        wtxhs: this.wtxhs
      }).then((res) => {
        if (res && res.data) {
          this.pjQx.forEach((item) => {
            let temp = res.data.filter((m) => m.WTXH == item.wtxh)
            item.roleList = temp
          })
        }
      })
    },
    wtRoleList(wtxh) {
      return this.pjQx.find((m) => m.wtxh == wtxh)?.roleList
    },
    pjInfo(wtxh) {
      return this.pjHistory.filter((m) => {
        return m.WTXH == wtxh
      })
    },
    // 历史整改信息
    GetZGHistory() {
      this.$requestApi('GetZGHistoryByWTXH', {
        wtxhs: this.wtxhs
      }).then((res) => {
        this.ZGHistory_1 = res.data
      })
      this.$requestApi('GetPJHistoryByWTXH', {
        wtxhs: this.wtxhs
      }).then((res) => {
        this.PJHistory_1 = res.data
      })
    },
    async getxtmj() {
      // 判断是否支持多次整改 0 否，1可多次评价 2必须护士长评价后才能护理部评价,也是多次评价
      this.$requestApi('GetXTMJList', { Mjdm: '1116' }).then((res) => {
        if (res.success) {
          let pjStr = res.data.find((m) => m.MJDM == 1116)
          this.showPj = pjStr && pjStr.JLZT == '1'
          if (this.showPj) {
            this.pjStr = pjStr.MJMC
          }
        }
      })
    },
    //获取备用字段信息
    getBY() {
      let that = this
      this.$requestApi('GetXTMJList', { Mjlx: '024' }).then((res) => {
        if (res.data) {
          res.data.forEach((item) => {
            let flag = that.BYList.find((m) => m.code == item.MJDM)
            if (flag) {
              flag.label = item.MJMC
              flag.need = item.JLZT == '1'
            }
          })
        }
      })
    },
    // 问题展示
    async getWtList() {
      let that = this
      that.pjOption = []
      await this.$requestApi('GetWTInfo', {
        wtxhs: this.wtxhs
      }).then((res) => {
        if (res.success) {
          that.wtData = res.data.map((m) => {
            that.pjOption.push({
              WTXH: m.WTXH,
              PLFXDM: Number(m.PLFXDM),
              PJZKJB: that.wtMap.get(m.WTXH)
            })
            m.CZWTMC = m.KFMC
            return m
          })
          if (that.wtData && that.wtData.length > 0) {
            var xfxhs = that.wtData.map((m) => m.XFXH).join(',')
            that.getUserList(xfxhs)

            that.wtData.forEach((m) => {
              m.WCSJ = moment(m.WCSJ).format('YYYY-MM-DD')
            })

            that.expandRow = [that.wtData[0].WTXH]
          }
          that.getZGInfo()
          this.GetPJDetailList()
        }
      })
    },
    // 整改内容
    getZGInfo() {
      let that = this
      this.$requestApi('GetZGInfo', {
        wtxhs: that.wtxhs
      }).then((res) => {
        if (res.data && res.data.length > 0) {
          that.wtData.forEach((element) => {
            let flag = res.data.find((m) => {
              return m.WTXH == element.WTXH
            })
            element.YYFX = flag.YYFX || ''
            element.ZGCS = flag.ZGCS || ''
            element.BY1 = flag.BY1 || ''
            element.BY2 = flag.BY2 || ''
            element.BY3 = flag.BY3 || ''
            element.ZGSJ = flag.ZGSJ
            element.ZGR = flag.ZGR
            element.ZGR_MC = flag.ZGR_MC
            element.ZXR = flag.ZXR
            element.ZXR_MC = flag.ZXR_MC
            element.ZgFileList = flag.ZgFileList
          })
          var plfxdmArr = []
          var fxxhArr = []
          res.data.forEach((item) => {
            if (item.PLFXDM && !plfxdmArr.some((m) => m == item.PLFXDM)) {
              plfxdmArr.push(item.PLFXDM)
            }
            if (item.FXXH && !fxxhArr.some((m) => m == item.FXXH)) {
              fxxhArr.push(item.FXXH)
            }
          })
          that.plfxdm = plfxdmArr.join(',')
          that.fxxh = fxxhArr.join(',')

          this.$set(that.wtData, 0, that.wtData[0])
        }
      })
    },
    //评价内容
    GetPJDetailList() {
      let that = this
      let wtxhCount = this.wtxhs.split(',').length || 0
      this.$requestApi('GetPJDetailListByWtxh', { wtxhs: this.wtxhs }).then(
        (res) => {
          // 如果有没有保存的数据，不能进行保存
          if (res.data) {
            // 用于展示
            that.pjList = res.data
            that.changeRole()
          }
        }
      )
    },
    changeRole() {
      let that = this
      let wtxhCount = this.wtxhs.split(',').length || 0
      if (that.readOnly) {
        that.pjHistory = that.pjList.filter((m) => m.SFPJ == 1)
      } else {
        that.pjHistory = that.pjList
          .filter((m) => m.SFPJ == 1)
          .map((m) => {
            let temp = that.pjOption.find((m) => m.WTXH == m.WTXH)
            m.canDel = m.PJZKJB == temp.PJZKJB
            return m
          })

        // 用于修改的列表
        let noSubmitList = []
        noSubmitList = that.pjList.filter((m) => {
          let temp = that.pjOption.find((k) => k.WTXH == m.WTXH)
          return m.SFZP == 0 && m.SFPJ == 0 && m.PJZKJB == temp.PJZKJB
        })

        if (wtxhCount > 1 && noSubmitList.length > 1) {
          for (let index = 1; index < noSubmitList.length; index++) {
            const nowItem = noSubmitList[index]
            const lastItem = noSubmitList[index - 1]
            if (
              nowItem.GJXGDM != lastItem.GJXGDM ||
              nowItem.GZPJ != lastItem.GZPJ ||
              nowItem.PJSJ != lastItem.PJSJ ||
              nowItem.PJRDM != lastItem.PJRDM ||
              nowItem.SHRDM != lastItem.SHRDM
            ) {
              this.$Confirm(
                '部分数据已存在评价记录，不能进行批量评价操作',
                '提示',
                {
                  confirmButtonText: '确定',
                  showCancelButton: false,
                  showClose: false,
                  closeOnClickModal: false,
                  type: 'warning'
                }
              )
                .then(() => {
                  that.$emit('close', { type: false })
                })
                .catch(() => {})
              return
            }
          }
        }

        that.pjData = []
        // 所有需要保存的记录都相同，或者只有一条保存记录
        if (noSubmitList.length > 0) {
          noSubmitList.forEach((m) => {
            let temp = that.pjData.find(
              (k) =>
                k.GZPJ == m.GZPJ &&
                k.PJJG.MJDM == m.GJXGDM &&
                k.PJR.id == m.PJRDM &&
                k.SHR.id == m.SHRDM
            )
            if (!temp) {
              that.pjData.push({
                ...m,
                PJJG: { MJDM: m.GJXGDM, MJMC: m.GJXGMC },
                PJR: { id: m.PJRDM, name: m.PJRMC },
                SHR: { id: m.SHRDM, name: m.SHRMC },
                canEdit: m.SFPJ != '1',
                DelJGDM: m.JGDM
              })
            } else {
              temp.DelJGDM += `,${m.JGDM}`
            }
            if (!that.cyList.some((k) => k.id == m.PJRDM)) {
              that.cyList.push({ id: m.PJRDM, name: m.PJRMC })
            }
            if (!that.cyList.some((k) => k.id == m.SHRDM)) {
              that.cyList.push({ id: m.SHRDM, name: m.SHRMC })
            }
          })
        } else {
          that.pjData = [{ ...that.pjObj }]
        }
      }

      that.$nextTick(() => {
        that.$refs.wtTable.doLayout()
        // 为了解决下拉框，切换后没有正确回显问题
        that.pjData.forEach((m, index) => {
          let pjr = m.PJR
          let shr = m.SHR
          that.$delete(that.pjData[index], 'PJR')
          that.$delete(that.pjData[index], 'SHR')
          that.$set(that.pjData[index], 'PJR', pjr)
          that.$set(that.pjData[index], 'SHR', shr)
        })
      })
    },
    //获取评价结果下拉框数据
    getPJResult() {
      this.$requestApi('GetXTMJList', { Mjlx: '012' }).then((res) => {
        this.pjResult = res.data.filter((m) => m.JLZT == '1')
        if (this.pjResult && this.pjResult.length) {
          this.pjObj.PJJG = this.pjResult[0]
        }
        this.pjObj.PJSJ = moment().format('YYYY-MM-DD')
      })
    },
    //获取评价人、审核人的人员列表
    getUserList(xfxhs) {
      this.$requestApi('GetPJUserList', { xfxhs: xfxhs }).then((res) => {
        this.cyList = res.data
      })
    },
    //弹出评价内容选择框
    popCheckPJ(row, title) {
      let width = window.innerWidth * 0.5
      let height = window.innerHeight * 0.7
      let bddms = this.wtData.map((m) => m.BDDM).join(',')
      let zzjgdms = this.wtData.map((m) => m.ZZJGDM).join(',')

      var index = this.$dlg.modal(zskSelect, {
        title: '知识库' + `-${title}`,
        width: width,
        height: height,
        params: { zskLx: '1116', bddms: bddms, zzjgdms: zzjgdms },
        callback: (data) => {
          if (data && data.length > 0) {
            var str = data.map((m) => m.MEMO).join(';')
            row.GZPJ += str
          }
        },
        cancelCallback: () => {}
      })
    },
    delPJ(id) {
      this.$Confirm('是否删除该条数据', '提示', {
        type: 'warning'
      })
        .then((res) => {
          DelPJ({ jgdm: id }).then((res) => {
            if (res.success) {
              this.$msg('操作成功', 'success')
              this.refresh = true
              this.GetPJDetailList()
            }
          })
        })
        .catch(() => {})
    },
    setPJJG(data) {
      //这时候组件不会重新渲染，需要重新设置值
      this.$set(this.pjData, data.$index, data.row)
    },
    // 保存或提交
    saveSubmit(type) {
      let that = this
      that.pjData.forEach((obj) => {
        obj.JGDM = obj.JGDM || -1
        obj.PLFXDM = that.plfxdm
        obj.FXXH = that.fxxh
        obj.GJXGDM = obj.PJJG.MJDM
        obj.GJXGMC = obj.PJJG.MJMC
        obj.CJR = that.UserInfo.UserId
        obj.SHRDM = obj.SHR.id || ''
        obj.SHRMC = obj.SHR.name || ''
        obj.PJRDM = obj.PJR.id || ''
        obj.PJRMC = obj.PJR.name || ''
        obj.IsSubmit = obj.SFPJ || type == 1
        obj.PJZKJB = that.pjjb
        obj.option = that.pjOption
      })

      if (that.showPj && that.pjData.some((m) => m.GZPJ.length == 0)) {
        that.$msg('请完善评价信息！')
        return
      }
      if (that.pjData.some((m) => !m.PJSJ || m.PJSJ.length == 0)) {
        that.$msg('请完善评价时间！')
        return
      }
      if (that.pjData.some((m) => !m.PJRDM || m.PJRDM.length == 0)) {
        that.$msg('请选择评价人！')
        return
      }
      if (that.pjData.some((m) => !m.SHRDM || m.SHRDM.length == 0)) {
        that.$msg('请选择审核人！')
        return
      }

      if (type == 1) {
        that
          .$Confirm('是否提交？', '提示', {
            type: 'warning'
          })
          .then((res1) => {
            that.refresh = true
            if (that.pjData.some((m) => m.GJXGDM == 1050)) {
              this.$Confirm(
                '问题需重新整改，建议生成新的问题并下发整改计划，是否生成？',
                '提示',
                {
                  type: 'warning'
                }
              )
                .then((res) => {
                  that.pjData.forEach((m) => {
                    m.type = 1
                  })
                  that.save(that.pjData, type)
                })
                .catch(() => {
                  // 重新整改的取消是取消生成新的问题，但是还会提交评价内容
                  if (that.pjData.some((m) => m.GJXGDM == 1050)) {
                    that.pjData.forEach((m) => {
                      m.type = 0
                    })
                    that.save(that.pjData, type)
                  }
                })
            } else {
              that.save(that.pjData, type)
            }
          })
      } else {
        that.refresh = true
        that.save(that.pjData, type)
      }
    },
    save(data, type) {
      const loading = this.$Loading({
        lock: true,
        text: 'Loading',
        spinner: 'w-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      SavePJ(data).then((res) => {
        loading.close()
        if (res.success) {
          this.$msg('操作成功', 'success')
          if (type == 1) {
            this.$emit('close', { type: this.refresh })
          } else {
            this.GetPJDetailList()
          }
        }
      })
    },
    exit() {
      this.$emit('close', { type: this.refresh })
    },
    getLastCheckList(val) {
      if (val.length > 0) {
        localStorage.setItem(
          'pj_detailDialog',
          JSON.stringify({
            showTableCheckList: val
          })
        )
      } else {
        localStorage.removeItem('pj_detailDialog')
      }
    }
  },
  windowConfigs: {
    maxButton: false,
    width: document.body.clientWidth,
    height: document.body.clientHeight
  }
}
</script>
<style lang="scss" scoped>
.form {
  margin-bottom: 20px;
}
.table-title {
  font-size: 13px;
  color: #666;
  margin: 5px 0;
  font-weight: bold;
}
.table-inner-row-text {
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.w-form-item {
  margin-bottom: 0;
}
/deep/ .w-table__expanded-cell {
  padding: 0 !important;
}
.reason-title {
  display: inline-block;
  margin-bottom: 10px;
}
.select-table-btn {
  position: absolute;
  right: 10px;
  top: 8px;
}
</style>
